

import { useNavigate } from "react-router-dom";
import { FaFileAlt, FaPenNib, FaMagic, FaDownload } from "react-icons/fa";


const Desktop25 = () => {
    const navigate = useNavigate(); // ✅ Initialize navigate function

    return (
        <div className="bg-[#f9f9f9] w-full overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-b from-[#06010A] to-[#260345] text-white flex flex-col md:flex-row items-center justify-between px-8 md:px-16 lg:px-24 py-20 overflow-hidden">
                {/* Decorative Ellipses */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#7B3FE4]/40 rounded-full blur-3xl top-[-100px] left-[-100px]" />
                    <div className="absolute w-[350px] h-[350px] bg-[#E6C1FF]/30 rounded-full blur-3xl bottom-[-150px] right-[-100px]" />
                </div>

                {/* Left Content */}
                <div className="relative z-10 max-w-xl">
                    <h3 className="text-lg text-[#ffffffbf] mb-3"> AI Job Matching</h3>
                    <h1 className="text-4xl md:text-5xl font-semibold leading-tight mb-6">
                        Discover the right job as easily as finding your next trip
                    </h1>
                    <p className="text-gray-200 mb-8 text-base md:text-lg">
                        We'll intelligently analyze your unique profile to uncover relevant job opportunities ,
                        highlighting your strengths and the specific skill gaps you can address for the perfect fit.
                    </p>

                    {/* ✅ Get Started Button linked to /auth */}
                    <button
                        onClick={() => navigate("/auth")}
                        className="bg-[#ffc403] text-black font-bold px-6 py-3 rounded-xl hover:bg-[#e6b800] transition"
                    >
                        Get Started
                    </button>
                </div>

                {/* Right Image */}
                <div className="relative z-10 mt-12 md:mt-0">
                    <img
                        src="https://c.animaapp.com/mge1sasxzrNszH/img/image-60.png"
                        alt="Resume Preview"
                        className="w-[350px] md:w-[450px] object-contain"
                    />
                </div>
            </section>

            {/* ================= CUSTOMIZE SECTION ================= */}
            <section className="relative bg-[#f9f9f9] text-[#22033c] py-24 px-6 md:px-16 text-center overflow-hidden">
                {/* Subtle Background Shapes */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#E7E4E9]/30 rounded-full blur-3xl top-[-150px] left-[-150px]" />
                    <div className="absolute w-[300px] h-[300px] bg-[#E7E4E9]/20 rounded-full blur-3xl bottom-[-100px] right-[-100px]" />
                </div>

                {/* Headings */}
                <div className="relative z-10 mb-16">
                    <h2 className="text-3xl md:text-4xl font-semibold mb-3">
                        Search smarter and find options faster
                    </h2>
                    <p className="text-gray-700 max-w-2xl mx-auto text-lg">
                        Explore opportunities scored based on how well they match your unique profile.
                    </p>
                </div>

                {/* Features */}
                <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 gap-12 max-w-6xl mx-auto">
                    {/* 1️⃣ personalized matches  */}
                    <div className="flex flex-col items-center text-center space-y-3">
                        <FaFileAlt className="w-10 h-10 text-[#22033c]" />
                        <h3 className="text-xl font-semibold">Personalized Matches</h3>
                        <p className="text-gray-700 text-base max-w-xs">
                            Instantly see openings that align with your experience, skills, and career goals.
                        </p>
                    </div>

                    {/* 2️⃣ Comprehensive search */}
                    <div className="flex flex-col items-center text-center space-y-3">
                        <FaPenNib className="w-10 h-10 text-[#22033c]" />
                        <h3 className="text-xl font-semibold">Comprehensive Search</h3>
                        <p className="text-gray-700 text-base max-w-xs">
                            Access job opportunities from top companies across the world — including remote-friendly roles.
                        </p>
                    </div>

                    {/* 3️⃣ Advance filtering  */}
                    <div className="flex flex-col items-center text-center space-y-3">
                        <FaMagic className="w-10 h-10 text-[#22033c]" />
                        <h3 className="text-xl font-semibold">Advance Filtering</h3>
                        <p className="text-gray-700 text-base max-w-xs">
                            Refine your search by job type, industry, experience level, or preferred location.
                        </p>
                    </div>
                </div>

                {/* One-click applications  */}
                <div className="relative z-10 mt-16 flex flex-col items-center text-center space-y-3">
                    <FaDownload className="w-10 h-10 text-[#22033c]" />
                    <h3 className="text-xl font-semibold">One-click Applications</h3>
                    <p className="text-gray-700 text-base max-w-md">
                        Upload your resume once and apply directly to multiple openings with a single click.
                    </p>
                </div>
            </section>




        </div>
    );
};

export default Desktop25;
